import fetchSeo from "common/fetch/fetchSeo";

import Layout from "components/common/Layout";
import IncorporationChecklist from "components/templates/common/incorporation-checklist";

import dataStatic from "./data.json";

export default function Home({ data }) {
  return (
    <Layout locationRouter="offshore" page={data?.page}>
      <IncorporationChecklist
        data={data}
        dataJson={dataStatic}
        widthBanner="lg:max-w-[410px] xl:max-w-[556px]"
      />
    </Layout>
  );
}

export const getStaticProps = async () => {
  const locale = "offshore";
  const uri = dataStatic.uri;
  const page = await fetchSeo({
    uri,
    locale,
  });

  return {
    props: {
      data: {
        page: page || {},
        posts: [],
      },
      revalidate: 1,
    },
  };
};
